import { render, staticRenderFns } from "./BuilderWebsiteConfig.vue?vue&type=template&id=15e48681&scoped=true"
import script from "./BuilderWebsiteConfig.vue?vue&type=script&lang=js"
export * from "./BuilderWebsiteConfig.vue?vue&type=script&lang=js"
import style0 from "./BuilderWebsiteConfig.vue?vue&type=style&index=0&id=15e48681&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e48681",
  null
  
)

export default component.exports